import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import toast from '../../shared/Toast';
import './ReceptionModals.css';

class VerifyPinModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pin: '',
            pinError: '',
            isSubmitting: false,
            attempts: 0,
            isLocked: false,
            lockoutEndTime: null
        };
    }

    handlePinChange = (e) => {
        const pin = e.target.value;
        if (/^\d{0,4}$/.test(pin)) {
            this.setState({ pin, pinError: '' });
        }
    }

    validateForm = () => {
        const { pin } = this.state;
        if (!pin || pin.length !== 4) {
            this.setState({ pinError: 'PIN must be 4 digits' });
            return false;
        }
        return true;
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validateForm()) {
            this.setState({ isSubmitting: true });
            try {
                this.props.onVerifyPin(this.state.pin);
                setTimeout(() => {
                    if (this.state.isSubmitting) {
                        this.setState({ isSubmitting: false });
                    }
                }, 500);
            } catch (error) {
                console.error('Error in PIN verification:', error);
                toast.error('An error occurred during verification. Please try again.');
                this.setState({ isSubmitting: false, pin: '' });
            }
        }
    }

    componentWillUnmount() {
        if (this.lockoutTimer) {
            clearTimeout(this.lockoutTimer);
        }
    }

    handleForgotPin = () => {
        this.props.onClose();
        if (this.props.onForgotPin) {
            this.props.onForgotPin();
        }
    }

    render() {
        const { onClose } = this.props;
        const { pin, pinError, isSubmitting } = this.state;

        return ReactDOM.createPortal(
            <div className="rm-modal-overlay" onClick={onClose}>
                <div className="rm-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="rm-modal-header">
                        <h3>{this.props.title || 'Verify PIN'}</h3>
                        <button className="rm-modal-close" onClick={onClose} type="button">&times;</button>
                    </div>
                    <div className="rm-modal-body">
                        <p>{this.props.message || 'Please enter your PIN to continue.'}</p>
                        <form onSubmit={this.handleSubmit}>
                            <div className="rm-form-group">
                                <label className="rm-label" htmlFor="pin">Enter PIN</label>
                                <input
                                    type="password"
                                    className={`rm-input${pinError ? ' rm-input--error' : ''}`}
                                    id="pin"
                                    value={pin}
                                    onChange={this.handlePinChange}
                                    placeholder="Enter 4-digit PIN"
                                    maxLength={4}
                                    autoComplete="current-password"
                                    disabled={isSubmitting}
                                    autoFocus
                                />
                                {pinError && <span className="rm-error">{pinError}</span>}
                            </div>
                            <div className="rm-modal-footer">
                                <button
                                    type="button"
                                    className="rm-btn rm-btn--link"
                                    onClick={this.handleForgotPin}
                                >
                                    Forgot PIN?
                                </button>
                                <button
                                    type="submit"
                                    className="rm-btn rm-btn--primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Verifying...' : 'Continue'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}

export default VerifyPinModal;
